import  { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import HIW1img from "images/empresa.png";
import HIW2img from "images/school.png";
import HIW3img from "images/movil.png";


export interface SectionHowItWorkProps {
  className?: string;
  data?: {
    id: number;
    title: string;
    desc: string;
    img: string;
    imgDark?: string;
  }[];
}

const DEMO_DATA: SectionHowItWorkProps["data"] = [
  {
    id: 1,
    img: HIW1img,
    title: "TEAM BUILDING EMPRESAS",
    desc: "Refuerza la unión de tu equipo cantando en nuestras salas privadas.",
  },
  {
    id: 2,
    img: HIW2img,
    title: "ACTIVIDADES ESCOLARES",
    desc: "Una experiencia divertida y segura para grupos escolares.",
  },
  {
    id: 3,
    img: HIW3img,
    title: "KARAOKE MÓVIL",
    desc: "Llevamos el karaoke a tu evento, estés donde estés.",
  },
];

const SectionHowItWork: FC<SectionHowItWorkProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {
  return (
    <div
      className={`nc-SectionHowItWork  ${className}`}
      data-nc-id="SectionHowItWork"
    >
      <div className="font-extrabold flex justify-center text-center dark:text-white text-black text-5xl sm:text-5xl md:text-5xl lg:text-6xl xl:text-6xl !leading-[115%]">
        <h2>
          KARAOKE HD
        </h2>
      </div>
      <div className="text-center">
        <span className="text-purple-600">Disfruta de nuestras salas y déjate llevar por el mood</span>

      </div>

      <div className="mt-20 relative grid md:grid-cols-3 gap-20">

        {data.map((item) => (
          <div
            key={item.id}
            className="relative flex flex-col items-center max-w-xs mx-auto"
          >
            {item.imgDark ? (
              <>
                <NcImage
                  containerClassName="dark:hidden mb-8 flex h-[200px] items-center justify-center max-w-[200px] mx-auto"
                  className="max-h-[200px] w-auto object-contain"
                  src={item.img}
                />
                <NcImage
                  containerClassName="hidden dark:flex mb-8 h-[200px] items-center justify-center max-w-[200px] mx-auto"
                  className="max-h-[200px] w-auto object-contain"
                  src={item.imgDark}
                />
              </>
            ) : (
              <NcImage
                containerClassName="mb-8 flex h-[200px] items-center justify-center max-w-[200px] mx-auto"
                className="max-h-[200px] w-auto object-contain"
                src={item.img}
              />
            )}
            <div className="text-center">
              <h3 className="flex min-h-[5.5rem] items-center justify-center text-4xl font-semibold text-white">{item.title}</h3>
              <span className="block mt-3 text-neutral-300">
                {item.desc}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
